import { useEffect, useLayoutEffect, useRef, useState } from "react";
import Image from "next/image";
import Button from "../ui/Button";
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import ButtonFill from "../ui/ButtonFill";
import useBgColorStore from "../../stores/bgColorStore";
import gsap from "gsap";
import cmsClient from "@/lib/cmsClient"
import Link from "next/link";
import { useRouter } from "next/router";


const PortfolioDisplay = ({ data, preselectCategory = ''}) => {
  const [filteresOpen, setFilteresOpen] = useState(false);

  const [openFilter, setOpenFilter] = useState(null);

  const router = useRouter()
  const { locale } = router

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSquare, setSelectedSquare] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);

  const [maxShowedItems, setMaxShowedItems] = useState(8);
  const [currentTotalItemsCount, setCurrentTotalItemsCount] = useState(data.items.data.total);

  const { currentColorClass } = useBgColorStore();

  const [projects, setProjects] = useState([]);
  const prevCategory = useRef(null);
  const prevSquare = useRef(null);
  const prevYear = useRef(null);

  const [loading, setLoading] = useState(false);

  const projectsContainer = useRef(null);

    const handleCategoryClick = () => {
      setOpenFilter(openFilter === 'category' ? null : 'category');
    };

    const handleSquareClick = () => {
      setOpenFilter(openFilter === 'square' ? null : 'square');
    };

    const handleYearClick = () => {
      setOpenFilter(openFilter === 'year' ? null : 'year');
    };

    const categoryFilterOpen = openFilter === 'category';
    const squareFilterOpen = openFilter === 'square';
    const yearFilterOpen = openFilter === 'year';

  const fetchProjects = async () => {
    const params = {
      category: selectedCategory?.slug || "",
      square: selectedSquare?.value || "",
      year: selectedYear?.value || "",
      per_page: maxShowedItems,
      lang: locale
    };

    const queryString = new URLSearchParams(params).toString();

    try {
      setLoading(true);
      setOpenFilter(null)
      setFilteresOpen(false)
       const res = await cmsClient(`/projects?${queryString}`);

       // console.log(res)
      // const res = await fetch(url);
      // if (!res.ok) {
      //   throw new Error("Failed to fetch projects");
      // }
      // const json = await res.json();
      setTimeout(()=> {
        ScrollTrigger.refresh();
      }, 500)
      // console.log(res)
      if (res.items) {
        setProjects(res.items);
      } else {
        setProjects([]);
      }
      setCurrentTotalItemsCount(res.total);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setProjects(data.items.data.items);
    setTimeout(()=> {
    ScrollTrigger.refresh();

    }, 500)
  }, [data.items.data]);

  useEffect(()=> {
    if (preselectCategory) {
      setSelectedCategory(preselectCategory)
    }
  }, [preselectCategory])

  useEffect(() => {
    if (selectedCategory || selectedSquare || selectedYear || maxShowedItems > 8) {
      fetchProjects();
    } else {
      setProjects(data.items.data.items);
      setCurrentTotalItemsCount(data.items.data.total);


    setTimeout(()=> {
      ScrollTrigger.refresh();
    }, 500)
      
    }
  }, [selectedCategory, selectedSquare, selectedYear, maxShowedItems]);




  const itemRefs = useRef([]);
  itemRefs.current = [];

  const addToRefs = (el) => {
    if (el && !itemRefs.current.includes(el)) {
      itemRefs.current.push(el);
    }
  };



  useLayoutEffect(() => {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {
      const anims = [];
      const animatedIndices1 = [1, 4, 9, 12, 17, 20, 25, 28];
      const animatedIndices2 = [2, 7, 10, 15, 18, 23, 26];

      itemRefs.current.forEach((el, i) => {
        if (animatedIndices1.includes(i)) {
          const anim = gsap.fromTo(
            el.firstChild,
            {  y: '13rem' },
            {
              y: 0,
              ease: 'none',
              scrollTrigger: {
                trigger: el,
              start: "top 70%",
              end: "top 20%",  
                scrub: 0.5
              },
            }
          );
          anims.push(anim);
        }

        if (animatedIndices2.includes(i)) {
          const anim = gsap.fromTo(
            el.firstChild,
            {  y: '15rem' },
            {
              y: 0,
              ease: 'none',
              scrollTrigger: {
                trigger: el,
              start: "top bottom",
              end: "top 35%",  
                scrub: 0.5
              },
            }
          );
          anims.push(anim);
        }
      });

      // Cleanup inside matchMedia
      return () => {
        anims.forEach((anim) => {
          anim.kill();
          anim.scrollTrigger?.kill();
        });
      };
    });

    // Cleanup entire matchMedia context
    return () => {
      mm.revert();
    };
  }, [projects, maxShowedItems]);

  const increaseMaxShowedItems = () => {
    setMaxShowedItems((prev)=>prev+=4)
    setTimeout(()=> {
      ScrollTrigger.refresh();

    }, 500)
  }

useEffect(() => {
  const categoryChanged =
    prevCategory.current?.slug !== selectedCategory?.slug;

  const squareChanged =
    prevSquare.current?.value !== selectedSquare?.value;

  const yearChanged =
    prevYear.current?.value !== selectedYear?.value;

  if ((categoryChanged || squareChanged || yearChanged) && projectsContainer.current) {

    const offset = 150; 

    if (window.pageYOffset > 100) {
      const y =
        projectsContainer.current.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      window.scrollTo({ top: y, behavior: "instant" });
    }
    

  }

  prevCategory.current = selectedCategory;
  prevSquare.current = selectedSquare;
  prevYear.current = selectedYear;
}, [projects]);


  return (
    <section  className="w-full container-max flex flex-col relative">
      <div className=" absolute top-0 left-0 z-[25] pointer-events-none h-full w-full">
      <div className={`w-full h-full absolute inset-0 transition-opacity duration-300 bg-dark-blue ${filteresOpen ? 'opacity-40 lg:opacity-0' : 'opacity-0'} ${(categoryFilterOpen || yearFilterOpen || squareFilterOpen) ? '!opacity-40' : 'opacity-0'}`}></div>

        <div className="sticky z-10 top-[5.6rem] pointer-events-auto md:top-[7.6rem] lg:top-[7.4rem] xl:top-[8.4rem]">
          <div className={`flex overflow-hidden  ${currentColorClass} transition-colors duration-500 lg:hidden justify-between items-center container-padding border-y-[1px] py-[2rem] border-dusty-blue-10`}>
            <button
              className="cursor-pointer"
              onClick={() => {
                setFilteresOpen((prev) => !prev)
              }}
            >
              <span className="heading-4 text-dusty-blue flex items-center">
                {data.filters.data.filter_title}
                <svg
                  className={`${filteresOpen ? "rotate-180" : ""} ml-[1.2rem]`}
                  width="15"
                  height="8"
                  viewBox="0 0 15 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1.5L7.5 6.5L14 1.5"
                    stroke="CurrentColor"
                    strokeWidth="1.3"
                  />
                </svg>
              </span>
            </button>

            {/* кнопка очистки */}
              <Link
                href={'/proekty'}
                onClick={() => {
                  setSelectedSquare(null)
                  setSelectedYear(null)
                  setMaxShowedItems(8)
                }}
                className={`${
                  selectedCategory || selectedSquare || selectedYear
                    ? "block"
                    : "hidden"
                } text-1 cursor-pointer underline-link text-dark-blue-40 hover:text-dark-blue transition-colors duration-300`}
              >
                {data.filters.data.clear_text}
              </Link>
            </div>
          <div>


            <div className={` w-full md:border-b-[1px] lg:border-t-[1px]  ${currentColorClass} transition-colors duration-500 container-padding container-grid border-dusty-blue-10 ${filteresOpen ? "grid lg:grid" : "lg:grid hidden"}`}>
              {/* Категория */}

              <div className="relative md:col-span-3 lg:col-span-5">
                <div className="  lg:flex lg:items-center border-b-[1px]  md:border-0 py-[2rem] border-dusty-blue-10">
                  <p className="text-1 mb-[1.2rem] lg:mb-0 lg:mr-[3.2rem]">{data.filters.data.category_text}</p>
                  <button
                    className="cursor-pointer"
                    onClick={
                      handleCategoryClick
                    }
                  >
                    <span
                      className={`${
                        selectedCategory ? "text-dusty-blue" : "text-dusty-blue-60"
                      } transition-colors heading-4 whitespace-nowrap flex hover:text-dusty-pink items-center`}
                    >
                      {selectedCategory ? selectedCategory.name : locale === 'ru' ? "Выбрать" : 'Select'}
                      <svg
                        className={`${categoryFilterOpen ? "rotate-180" : ""} ml-[1.2rem]`}
                        width="15"
                        height="8"
                        viewBox="0 0 15 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1.5L7.5 6.5L14 1.5"
                          stroke="CurrentColor"
                          strokeWidth="1.3"
                        />
                      </svg>
                    </span>
                  </button>
                </div>

                <div
                  className={`${
                    categoryFilterOpen ? "opacity-100 pointer-events-auto flex" : "opacity-0 hidden md:flex pointer-events-none "
                  }  border-b-[1px] md:transition-opacity duration-300 md:absolute md:top-[calc(100%+1px)] md:left-[4rem]  ${currentColorClass} transition-colors duration-500  md:p-[2.4rem] md:border-0 flex flex-col gap-[1.2rem] text-start items-start py-[2rem] border-dusty-blue-10`}
                >
                  {data.filters.data.categories.map((item, index) => (
                    <Link
                      href={`/proekty/${item.url ? item.url : item.slug}`}
                      onClick={() => {
                        setSelectedCategory(item)
                        handleCategoryClick()
                      }}
                      key={index}
                      className="cursor-pointer"
                    >
                    <span className={`${selectedCategory?.name === item.name ? ` text-dusty-blue pl-[1.5rem] before:content-[''] before:absolute before:left-[0] before:top-1/2 before:-translate-y-1/2 before:w-[0.4rem] before:h-[0.4rem] before:bg-dusty-blue before:transition-colors` : 'text-dusty-blue-60'} heading-4 relative md:text-nowrap hover:before:bg-dusty-pink hover:text-dusty-pink transition-colors`}>

                        <span className="inline-block md:hidden">
                          {item.name.length > 25 ? item.name.substring(0, 25) + "..." : item.name}
                        </span>
                        <span className="hidden md:inline-block">
                          {item.name}
                        </span>
                      </span>
                    </Link>
                  ))}
                </div>
              </div>

            {/* Площадь */}

            <div className={"relative lg:col-span-2 "}>
              <div className=" lg:flex lg:items-center border-b-[1px]  md:border-0 py-[2rem] border-dusty-blue-10">
                <p className="text-1 mb-[1.2rem] lg:mb-0 lg:mr-[3.2rem]">{data.filters.data.square_text}</p>
                <button
                  className="cursor-pointer"
                  onClick={handleSquareClick}
                >
                  <span
                    className={`${
                      selectedSquare ? "text-dusty-blue" : "text-dusty-blue-60"
                    } transition-colors heading-4 whitespace-nowrap hover:text-dusty-pink flex items-center`}
                  > 
                    {selectedSquare ? selectedSquare.text : locale === 'ru' ? "Выбрать" : 'Select'}
                    <svg
                      className={`${squareFilterOpen ? "rotate-180" : ""} ml-[1.2rem]`}
                      width="15"
                      height="8"
                      viewBox="0 0 15 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1.5L7.5 6.5L14 1.5"
                        stroke="CurrentColor"
                        strokeWidth="1.3"
                      />
                    </svg>
                  </span>
                </button>
              </div>

              <div
                className={`${
                  squareFilterOpen ? "opacity-100 pointer-events-auto flex" : "opacity-0 hidden md:flex pointer-events-none "
                  }  border-b-[1px] md:transition-opacity duration-300  md:border-0 md:left-[4rem] md:top-[calc(100%+1px)] md:bg-beige md:p-[2.4rem] md:absolute flex flex-col gap-[1.2rem] text-start items-start py-[2rem] border-dusty-blue-10`}
              >
                {data.filters.data.squares.map((item, index) => (
                  <button
                    onClick={() => {
                      setSelectedSquare(item)
                      handleSquareClick()
                    }}
                    key={index}
                    className="cursor-pointer"
                  >
                    <span className={`${selectedSquare?.text === item.text ? ` text-dusty-blue pl-[1.5rem] before:content-[''] before:absolute before:left-[0] before:top-1/2 before:-translate-y-1/2 before:w-[0.4rem] before:h-[0.4rem] before:bg-dusty-blue before:transition-colors` : 'text-dusty-blue-60'} heading-4 relative md:text-nowrap hover:before:bg-dusty-pink hover:text-dusty-pink transition-colors`}>
                      {item.text}
                    </span>
                  </button>
                ))}
              </div>
            </div>


            {/* Год */}
            <div className={"relative lg:col-span-2 lg:col-start-10 md:flex md:justify-end lg:justify-start lg:w-full "}>
              <div className="  border-b-[1px] lg:flex lg:items-center md:border-0 py-[2rem]  border-dusty-blue-10">
                <p className="text-1 mb-[1.2rem] lg:mb-0 lg:mr-[3.2rem]">{data.filters.data.year_text}</p>
                <button
                  className="cursor-pointer"
                  onClick={handleYearClick}
                >
                  <span
                    className={`${
                      selectedYear ? "text-dusty-blue" : "text-dusty-blue-60"
                    } transition-colors heading-4 flex whitespace-nowrap hover:text-dusty-pink items-center`}
                  >
                    {selectedYear ? selectedYear.text : locale === 'ru' ? "Выбрать" : 'Select'}
                    <svg
                      className={`${yearFilterOpen ? "rotate-180" : ""} ml-[1.2rem]`}
                      width="15"
                      height="8"
                      viewBox="0 0 15 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1.5L7.5 6.5L14 1.5"
                        stroke="CurrentColor"
                        strokeWidth="1.3"
                      />
                    </svg>
                  </span>
                </button>
              </div>

              <div
                className={`${
                  yearFilterOpen ? "opacity-100 pointer-events-auto flex" : "opacity-0 hidden md:flex pointer-events-none "
                  }  border-b-[1px] md:transition-opacity duration-300 flex flex-col md:border-0 md:top-[calc(100%+1px)] md:p-[2.4rem] md:bg-beige md:absolute gap-[1.2rem] text-start items-start py-[2rem] border-dusty-blue-10`}
              >
                {data.filters.data.years.map((item, index) => (
                  <button
                    onClick={() => {
                      setSelectedYear(item)
                      handleYearClick()
                    }}
                    key={index}
                    className="cursor-pointer"
                  >
                    <span className={`${selectedYear?.text === item.text ? ` text-dusty-blue pl-[1.5rem] before:content-[''] before:absolute before:left-[0] before:top-1/2 before:-translate-y-1/2 before:w-[0.4rem] before:h-[0.4rem] before:bg-dusty-blue before:transition-colors` : 'text-dusty-blue-60'} heading-4 relative md:text-nowrap hover:before:bg-dusty-pink hover:text-dusty-pink transition-colors`}>
                      {item.text}
                    </span>
                  </button>
                ))}
              </div>
            </div>

            <div className="hidden lg:flex items-center  lg:col-start-12 justify-end ">
              <Link
                href={'/proekty'}
                onClick={() => {
                  setSelectedSquare(null)
                  setSelectedYear(null)
                  setMaxShowedItems(8)
                }}
                className={`${
                  selectedSquare || selectedYear
                    ? "block"
                    : "hidden"
                } text-1 cursor-pointer whitespace-nowrap underline-link text-dark-blue-40 hover:text-dark-blue transition-colors duration-300`}
              >
                {data.filters.data.clear_text}
              </Link>
            </div>
            </div>
          </div>
        </div>
      </div>

        {loading ? (
          <div className="w-full flex fixed items-center z-50 top-0 left-0 pointer-events-none h-screen justify-center">
            <div className="loader">
            <div><span></span></div>
            <div><span></span></div>
            <div><span></span></div>
            <div><span></span></div>
            <div><span></span></div>
            <div><span></span></div>
            <div><span></span></div>
            <div><span></span></div>
          </div></div>
          ) : null}

      <div ref={projectsContainer} className="pt-[8.5rem] md:pt-[9rem] lg:pt-[12rem]  min-h-[20rem] w-full py-[2rem] md:pb-[2.4rem] container-padding gap-x-[1.6rem] gap-y-[4.4rem] lg:gap-y-[10rem] lg:gap-x-[8.3%] xl:gap-y-[12rem] grid md:grid-cols-2">

                      <>

        {projects.length === 0 ? <div className="w-full pt-[4rem] lg:text-center lg:col-span-2 pb-[4.8rem] text-left flex flex-col ">
                                    <h3 className="mb-[1.2rem] heading-4 xl:mb-[2rem]">
                                      {locale === 'ru' ? "Поиск не дал результатов" : "No results found"}
                                    </h3>

                                    <p className="text-1 max-w-[37.5rem] md:max-w-[70rem] lg:max-w-none">
                                      {locale === 'ru'
                                        ? "Примените другие фильтры или полностью очистите их, чтобы начать поиск заново"
                                        : "Try different filters or clear them completely to start a new search"}
                                    </p>
                                  </div> : null}



{projects.map((item, index) => {
  const rowIndex = Math.floor(index / 2) + 1;
  const isLeft = index % 2 === 0;


  let customStyleWrapper = "";
  let customStyleBlock = "";
  let customStyleImage = "";


  if ((rowIndex - 1) % 4 === 0) {
    // rows 1, 5, 9...
    customStyleBlock = isLeft ? "lg:w-[100%]" : "lg:w-[59%]";
    customStyleWrapper = isLeft ? " lg:justify-start" : " lg:justify-end";

    customStyleImage = "lg:aspect-[1.69]";

  } else if ((rowIndex - 3) % 4 === 0) {
    // rows 3, 7, 11...
    customStyleBlock = isLeft ? "lg:w-[59%]" : "lg:w-[100%]";
    customStyleWrapper = isLeft ? " lg:justify-start" : " lg:justify-end";
    customStyleImage = "lg:aspect-[1.69]";


  } else {
    // rows 2, 4, 6, 8, 10...
    customStyleBlock = isLeft ? "lg:w-[59%]" : "lg:w-[59%]";
    customStyleWrapper = isLeft ? " lg:justify-end" : " lg:justify-start";
    customStyleImage = "lg:aspect-[0.816]";

  }

  return (
    <div
      key={index}
      ref={addToRefs}
      className={`w-full flex  ${customStyleWrapper}`}
    >

      <div className={`${customStyleBlock} w-full`}>
        <a href={item.link} className="cursor-pointer">
        <div className={`mb-[1.4rem] group overflow-hidden p-[1.2rem] md:p-[1.6rem] flex items-end justify-end lg:items-center lg:justify-center relative ${customStyleImage} aspect-[1.2/1] w-full`}>
          <Image
            src={item?.image?.url}
            alt={item?.image?.alt}
            fill
            fetchPriority={index === 0 ? "high" : 'auto'}
            priority={index === 0}
            sizes="(max-width: 768px) 350px, 850px"
            className="w-auto lg:group-hover:scale-[1.03] duration-300 transition-transform object-cover"
          />
          {
            item.image_hover ? <Image
            src={item?.image_hover?.url}
            // src={'/images/temporal/project_hover.png'}
            alt={item?.image_hover?.alt}
            fill
            sizes="(max-width: 768px) 350px, 600px"
            className="w-auto lg:group-hover:opacity-30 lg:group-hover:scale-[1.03] hidden lg:block opacity-0 duration-300 transition-[opacity, transform] z-20 object-cover"
          /> : null

          }

          <div className="absolute z-10 lg:group-hover:opacity-100 opacity-0 transition-opacity duration-300 inset-0 bg-dark-blue-40  backdrop-blur-[0.5rem]"></div>
          
          <div className="flex hover:bg-dusty-blue hover:text-white transition-colors h-[3.2rem] w-[3.2rem] items-center cursor-pointer justify-center bg-dusty-green text-btn relative z-10 lg:hidden" href={item.link}>
          {/* <ButtonIcon > */}
            <img
              className="-rotate-45 w-[1.4rem] h-[1.4rem]"
              fetchPriority="low"
              src="/images/arrow_right.svg"
              alt="Стрелка вправо"
            />
          {/* </ButtonIcon> */}
          </div>    
          <div className="relative lg:group-hover:opacity-100 opacity-0 z-20 transition-opacity hidden lg:block " >
            <Button notAnimated={true} className="[&>div]:hidden">{locale === 'ru' ? 'смотреть проект' : 'View project'}<svg className='' width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 7H12M12 7L6 1M12 7L6 13" stroke="CurrentColor"/>
               </svg>
            </Button>
          </div>
        </div>
              </a>

        <div className="w-full">
          <div className="mb-[1rem] w-full flex gap-[2.4rem] justify-between">
            <p className="caption text-dark-blue opacity-60">
  {selectedCategory ? item.categories.find(cat => cat.name === selectedCategory.name)?.name || item.categories[0]?.name : item.categories[0]?.name}
            </p>
            <p className="caption text-right text-dark-blue opacity-60">
              {item.square}{item.square && item.year ? '/' : ''}{item.year}
            </p>
          </div>
           <a href={item.link} className="cursor-pointer">
            <h3 className="heading-4">{item.title}</h3>
          </a>
        </div>
      </div>


    </div>
  );
})}</>
      </div>

      <div className="relative pt-[1.2rem] md:flex-row items-center gap-[3.2rem] justify-center pb-[6rem] flex flex-col md:pt-[4.8rem] md:pb-[8rem] xl:pt-[6rem] xl:pb-[12rem] w-full container-padding">
        {/* {projects.length > 0 ? <button onClick={scrollToBlock} className="group flex cursor-pointer items-center mb-[3.2rem] md:mb-0">
          <p className="text-btn-big mr-[2rem] lg:opacity-0 lg:group-hover:opacity-100 transition-opacity duration-300">подняться наверх</p>
          <div 
            className={`flex group-hover:bg-dusty-blue group-hover:text-white transition-colors h-[3.2rem] w-[3.2rem] items-center cursor-pointer justify-center bg-dusty-green text-btn `}
          >
            <svg className='-rotate-90 ' width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 7H12M12 7L6 1M12 7L6 13" stroke="CurrentColor"/></svg>
          </div>
        </button> : null} */}

        {maxShowedItems < currentTotalItemsCount && projects.length  ? <ButtonFill onClick={increaseMaxShowedItems} className="md:w-fit ">{locale === 'ru' ? 'показать больше' : 'show more'} <svg className='rotate-90 ml-[1.3rem]' width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 7H12M12 7L6 1M12 7L6 13" stroke="CurrentColor"/>
                        </svg>
        </ButtonFill> : null}

        <a href={locale === 'ru' ? '/proekty-vse/' : '/en/projects-all/'} className="cursor-pointer text-link">{locale === 'ru' ? 'Смотреть все' : 'View all'}</a>

      </div>


    </section>
  )
}

export default PortfolioDisplay
